/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {map, Observable} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {HTTP_CODE_SUCCESS} from '@shared/constants';
import {
  LocationFormInterface,
  LocationListInterface, LocationsSummaryInterface
} from '@shared/interface';

@Injectable()
export class MkadLocationsServices extends MkadBaseService {
  readonly customer = URLS_SERVICE.meerkad.customer;
  readonly locations = URLS_SERVICE.meerkad.location;

  summary(param: object): Observable<LocationsSummaryInterface[]> {
    return this.http.post<LocationsSummaryInterface[]>(this.customer.base + this.locations.base + this.locations.summary, param);
  }

  list(): Observable<LocationListInterface[]> {
    return this.http.post<LocationListInterface[]>(this.customer.base + this.locations.base + this.locations.list);
  }

  get(groupId: number): Observable<LocationListInterface> {
    return this.http.post<LocationListInterface>(this.customer.base + this.locations.base + this.locations.get, {id: groupId});
  }

  create(toCreate: LocationFormInterface): Observable<LocationFormInterface> {
    return this.http.post<LocationFormInterface>(this.customer.base + this.locations.base + this.locations.create, toCreate);
  }

  delete(groupId: number): Observable<boolean> {
    return this.http.post<HttpResponse<boolean>>(this.customer.base + this.locations.base + this.locations.delete, {id: groupId}).pipe(
      map((prevResponse) => {
          if (!prevResponse) return true;
          return prevResponse.status === HTTP_CODE_SUCCESS;
        },
      ));
  }

  update(toUpdate: LocationFormInterface): Observable<LocationFormInterface> {
    return this.http.post<LocationFormInterface>(this.customer.base + this.locations.base + this.locations.update, toUpdate);
  }

}
